export default "__VITE_ASSET__DYja1lcc__"